import { SvgIcon } from "@mui/material"

import { ReactComponent as CheckboxIcon } from "./checkedIcon.svg"

export const CheckboxCheckedIcon = (props) => {
    return (
        <SvgIcon component={CheckboxIcon} {...props} inheritViewBox />
    )
}

